(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lamella-family-service"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumarlo-contact-picker')) {
    customElements.define('lumarlo-contact-picker', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[role="dialog"]');
        if (!this.panel) return;
        this.bypass = false;
        this.onDocumentClick = (event) => {
          const path = event.composedPath();
          const host = path.find((node) => node instanceof Element && node.matches('shopify-chat'));
          const activator = path.find((node) => node instanceof Element && node.matches('button[part~="activator"]'));
          if (!this.bypass && host && activator && !host.hasAttribute('open') && (activator.getAttribute('aria-expanded') !== 'true' || !this.panel.hidden)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.activator = activator;
            this.host = host;
            if (this.panel.hidden) this.open();
            else this.close(true);
            return;
          }
          if (!this.panel.hidden && !path.includes(this.panel)) this.close(false);
        };
        this.onKeydown = (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) {
            event.preventDefault();
            event.stopPropagation();
            this.close(true);
          }
        };
        this.onFocus = (event) => {
          const path = event.composedPath();
          const launcher = path.find((node) => node instanceof Element && node.matches('button[part~="activator"]'));
          const host = path.find((node) => node instanceof Element && node.matches('shopify-chat'));
          if (launcher && host && !host.hasAttribute('open')) {
            launcher.setAttribute('aria-label', this.dataset.launcherLabel);
            launcher.setAttribute('aria-haspopup', 'dialog');
          }
          if (!this.panel.hidden && !event.composedPath().includes(this.panel) && !event.composedPath().includes(this.activator)) this.close(false);
        };
        this.onResize = () => this.close(false);
        this.onPanelClick = (event) => {
          if (event.target.closest('[data-contact-close]')) {
            this.close(true);
            return;
          }
          if (event.target.closest('[data-contact-chat]')) {
            const host = this.host;
            const activator = this.findActivator(host);
            if (!host || !activator) return;
            event.preventDefault();
            event.stopPropagation();
            this.close(false);
            if (host.hasAttribute('open') || activator.getAttribute('aria-expanded') === 'true') return;
            this.bypass = true;
            try { activator.click(); }
            finally { this.bypass = false; }
          } else if (event.target.closest('a')) this.close(false);
        };
        document.addEventListener('click', this.onDocumentClick, true);
        document.addEventListener('keydown', this.onKeydown, true);
        document.addEventListener('focusin', this.onFocus);
        window.addEventListener('resize', this.onResize);
        this.panel.addEventListener('click', this.onPanelClick);
      }
      findActivator(root) {
        if (!root) return null;
        const button = root.querySelector('button[part~="activator"]');
        if (button) return button;
        if (root.shadowRoot) {
          const nested = this.findActivator(root.shadowRoot);
          if (nested) return nested;
        }
        for (const child of root.querySelectorAll('*')) {
          if (!child.shadowRoot) continue;
          const nested = this.findActivator(child.shadowRoot);
          if (nested) return nested;
        }
        return null;
      }
      open() {
        const bounds = this.activator.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        this.panel.style.right = Math.max(16, Math.min(viewportWidth - bounds.right, viewportWidth - Math.min(328, viewportWidth - 32) - 16)) + 'px';
        const panelBottom = Math.max(84, window.innerHeight - bounds.top + 12);
        this.panel.style.bottom = panelBottom + 'px';
        this.panel.style.maxHeight = Math.max(0, window.innerHeight - panelBottom - 16) + 'px';
        this.panel.hidden = false;
        this.activator.setAttribute('aria-label', this.dataset.launcherLabel);
        this.activator.setAttribute('aria-haspopup', 'dialog');
        this.activator.setAttribute('aria-expanded', 'true');
        this.panel.querySelector('[data-contact-chat]').focus({ preventScroll: true });
      }
      close(restoreFocus) {
        if (this.panel.hidden) return;
        this.panel.hidden = true;
        if (!this.host?.hasAttribute('open')) this.findActivator(this.host)?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.findActivator(this.host)?.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick, true);
        document.removeEventListener('keydown', this.onKeydown, true);
        document.removeEventListener('focusin', this.onFocus);
        window.removeEventListener('resize', this.onResize);
        this.panel?.removeEventListener('click', this.onPanelClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumarlo-care"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumarlo-care')) {
    customElements.define('lumarlo-care', class extends HTMLElement {
      connectedCallback() {
        this.onTopicClick = (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('a[data-care-topic]');
          if (!link || !this.contains(link)) return;
          const select = this.querySelector('[data-care-select]');
          const option = select && [...select.options].find(item => item.dataset.careValue === link.dataset.careTopic);
          if (!option) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          select.focus({ preventScroll: true });
        };
        this.addEventListener('click', this.onTopicClick);
        this.querySelector('[data-care-status]')?.focus();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onTopicClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  function openLumarloPolicy(hash) {
    if (hash !== '#LumarloSoonPrivacy' && hash !== '#LumarloSoonLegal') return;
    const policy = document.querySelector(hash);
    if (policy instanceof HTMLDetailsElement) policy.open = true;
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.lm-soon a[href^="#LumarloSoon"]');
    if (link) openLumarloPolicy(link.hash);
  });
  window.addEventListener('hashchange', () => openLumarloPolicy(window.location.hash));
  openLumarloPolicy(window.location.hash);

  } catch(e) { console.error(e); }
})();
})();
